import axios from "axios";

export function fetchOrdersAction(bid) {
    return {
        type: 'FETCH_ORDERS',
        meta: {
            bid: bid
        },
        payload: async () => {
            const orders_resp = await axios.get('/api/v2a/getOrders', {params: {bid}});

            return orders_resp.data;
        }
    };
}

export function deleteOrderAction(bid, orderId) {
    return {
        type: "DELETE_ORDER",
        meta: {
            bid: bid,
            orderId: orderId
        },
        payload: axios.post('/api/v2a/deleteOrder', {
            "orderId": orderId,
            "bid": bid
        })
    };
}

export function sendWithOrcaAction(bid, orderId) {
    return async (dispatch) => {
        await dispatch({
            type: "SEND_WITH_ORCA",
            meta: {
                bid: bid,
                orderId: orderId
            },
            payload: async () => {
                const response = await axios.post('/api/v2a/sendWithOrca', {
                    bid: bid,
                    orderId: orderId
                });

                return response.data;
            }
        });

        dispatch(changeOrdersStatusUI([orderId], "ASSIGNED_TO_ORCA"));
    };
}

export function addOrderAction(order) {
    return {
        type: "ADD_ORDER",
        meta: order,
        payload: axios.post('/api/v2a/newOrder', order)
    };
}

export function editOrderAction(order) {
    return {
        type: "EDIT_ORDER",
        meta: order,
        payload: axios.post('/api/v2a/updateOrder', order)
    };
}

export function setOrdersStatusAction(bid, orderIds, status) {
        return {
        type: "SET_ORDERS_STATUS",
        meta: {
            bid: bid,
            orderIds: orderIds,
            status: status
        },
        payload: axios.post('/api/v2a/setOrdersStatus', {
            bid: bid,
            orderIds: orderIds,
            status: status
        })
    };
}

export function scheduleNotificationOrderAction(bid, orderId, notifyToBid, arrivalMinutes) {
    return {
        type: "SCHEDULE_NOTIFICATION_ORDER",
        meta: {
            bid: bid,
            orderId: orderId,
            notifyToBid: notifyToBid,
            arrivalMinutes: arrivalMinutes
        },
        payload: axios.post('/api/v2a/scheduleNotificationOrder', {
            "orderId": orderId,
            "bid": bid,
            "notifyToBid": notifyToBid,
            "arrivalMinutes": arrivalMinutes
        })
    };
}

export function redirectOrderAction(bid, orderId, redirectToBid) {
    return {
        type: "REDIRECT_ORDER",
        meta: {
            bid: bid,
            redirectToBid: redirectToBid,
            orderId: orderId
        },
        payload: axios.post('/api/v2a/redirectOrder', {
            "orderId": orderId,
            "bid": bid
        })
    };
}


export function changeOrdersStatusUI(ordersIds, status) {
    return {
        type: "CHANGE_ORDERS_STATUS",
        meta: {ordersIds, status}
    };
}